(ns common.schema.entities.email-template
  (:require
   [common.schema.schema-utils :as su]))

(def schema
  (concat
   (su/text-simple-field :email-template/subject "Subject" {:default-field-visibility :in-use})
   (su/text-multiline-field :email-template/body "Email body" {:default-field-visibility :in-use})
   (su/text-simple-field :email-template/footer "Subject" {:default-field-visibility :in-use})
   (su/multi-ref-field :email-template/related-to "Related to" nil {:default-field-visibility :in-use})))

